import { apiCall } from '../apiHelpers';

// User functions
export const createUserDocument = async (user) => {
  const createdUser = await apiCall('/v1/users', {
    method: 'POST',
    body: JSON.stringify({
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
    }),
  });
  return createdUser;
};

export const getUserDocument = async (userId) => {
  const user = await apiCall(`/v1/users/${userId}`);
  return user;
};

export const getAllUsers = async () => {
  const users = await apiCall('/v1/users');
  return users;
};

export const updateNotificationPreferences = async (userId, preferences) => {
  const user = await apiCall(`/v1/users/${userId}/notification-preferences`, {
    method: 'PATCH',
    body: JSON.stringify(preferences),
  });
  return user;
};

export const updateUserProfile = async (userId, profileData) => {
  const params = new URLSearchParams({ userId: userId.toString() });
  const user = await apiCall(`/v1/users/${userId}/profile?${params}`, {
    method: 'PATCH',
    body: JSON.stringify(profileData),
  });
  return user;
};

export const setVacationMode = async (userId, enabled) => {
  const params = new URLSearchParams({ userId: userId.toString() });
  return apiCall(`/v1/users/${userId}/vacation-mode?${params}`, {
    method: 'POST',
    body: JSON.stringify({ enabled }),
  });
};

export const deleteAccount = async (userId) => {
  const params = new URLSearchParams({ userId: userId.toString() });
  return apiCall(`/v1/users/${userId}?${params}`, {
    method: 'DELETE',
  });
};

